import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateOrganizationBody,
  OrganizationApi,
  UpdateOrganizationEnableInviteOnlyBody,
  UpdateOrganizationEnrichmentSourceBody,
  UpdateSubOrganizationBody,
} from '../../api/organization/organization.api';

export const usePostOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ body, id }: { body: CreateOrganizationBody; id: string }) =>
      OrganizationApi.createOrganization({ body }),
    onSuccess: () => {
      // Invalidate orgs
      queryClient.invalidateQueries(['currentOrganization']);
    },
  });
};

export const usePutOrganizationEnableInviteOnly = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      body,
      id,
    }: {
      body: UpdateOrganizationEnableInviteOnlyBody;
      id: string;
    }) =>
      OrganizationApi.updateOrganizationEnableInviteOnly({
        body,
        id,
      }),
    onSuccess: () => {
      // Invalidate orgs
      queryClient.invalidateQueries(['currentOrganization']);
    },
  });
};

export const usePutOrganizationEnrichmentSource = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      body,
      id,
    }: {
      body: UpdateOrganizationEnrichmentSourceBody;
      id: string;
    }) =>
      OrganizationApi.updateOrganizationEnrichmentSource({
        body,
        id,
      }),
    onSuccess: () => {
      // Invalidate orgs
      queryClient.invalidateQueries(['currentOrganization']);
    },
  });
};

export const usePutSubOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      body,
      organizationId,
      subOrganizationId,
    }: {
      body: UpdateSubOrganizationBody;
      organizationId: string;
      subOrganizationId: string;
    }) =>
      OrganizationApi.updateSubOrganization({
        body,
        organizationId,
        subOrganizationId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(['childOrganizations']);
    },
  });
};
